import styled from '@emotion/styled'
import {theme} from '../../theme'

export const ButtonGroupWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${theme.palette.blueGray[100]};
  border-radius: ${theme.radii.full};
  overflow: hidden;
`

export const ButtonGroupItem = styled.button`
  display: flex;
  align-items: center;
  gap: ${theme.space[1.5]};
  padding: ${theme.space[2]} ${theme.space[4]};
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: ${theme.fonts.body};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.secondary};
  white-space: nowrap;

  &:hover {
    color: ${theme.colors.text.primary};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const ButtonGroupDivider = styled.div`
  width: 1px;
  align-self: stretch;
  background: ${theme.palette.blueGray[200]};
`
